<template>
  <PeppolContainer size="extra-small">
    <div
      v-if="invoice.peppol_sended_at"
      class="flex items-center gap-2 rounded border bg-primary-50 px-1 py-0.5"
    >
      <FontAwesomeIcon
        :icon="['fas', 'circle-check']"
        class="text-primary-600"
      />
      <span class="font-bold">
        {{
          invoice.peppol_sended_at !== null
            ? $t('global.sended_at', {
                date: $h.formatDate(invoice.peppol_sended_at, 'LLL')
              })
            : $t('global.sended')
        }}
      </span>
    </div>
    <template v-else>
      <div v-if="isPeppolReady" class="flex flex-col gap-1.5">
        <BaseButton
          :title="$t('button.peppol.send_via_peppol')"
          size="extra-small"
          icon="paper-plane"
          inverse-icon-order
          block
          :display-loader="sending"
          :disabled="sending"
          data-faro-user-action-name="invoice.send_peppol"
          @click="sendInvoiceViaPeppol"
        />
      </div>
      <div v-else>
        <BaseButton
          :title="$t('button.peppol.check_peppol')"
          size="extra-small"
          icon="paper-plane"
          inverse-icon-order
          block
          :display-loader="sending"
          :disabled="sending"
          @click="checkPeppolInvoiceable"
        />
      </div>
    </template>
  </PeppolContainer>
</template>

<script>
import { mapActions } from 'vuex'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import PeppolContainer from '@c/Partner/Peppol/PeppolContainer.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'PeppolSendInvoiceComponent',
  components: {
    FontAwesomeIcon,
    PeppolContainer,
    BaseButton
  },
  props: {
    invoice: {
      type: Object,
      required: true
    },
    printSettings: {
      type: Object,
      required: true
    }
  },
  emits: ['refresh-invoice'],
  data() {
    return {
      sending: false
    }
  },
  computed: {
    isPeppolReady() {
      return (
        Array.isArray(this.invoice?.invoiceable?.peppol_identifiers) &&
        this.invoice.invoiceable.peppol_identifiers.length > 0
      )
    }
  },
  methods: {
    ...mapActions({
      processCheckPeppolInvoiceableAction: 'company/checkPeppolInvoiceable',
      processSendInvoiceViaPeppolAction: 'company/sendInvoiceViaPeppol'
    }),
    checkPeppolInvoiceable() {
      this.sending = true
      this.processCheckPeppolInvoiceableAction({
        id: this.invoice.id,
        params: {
          model_type: this.invoice.invoiceable_normalized?.type,
          model_id: this.invoice.invoiceable_normalized?.id,
          company_id: this.invoice.company?.id
        }
      })
        .then((response) => {
          if (response.success) {
            this.$emit('refresh-invoice')
          } else {
            this.$h.toastWarning(response.message)
          }
        })
        .finally(() => {
          this.sending = false
        })
    },
    sendInvoiceViaPeppol() {
      this.sending = true
      this.processSendInvoiceViaPeppolAction({
        id: this.invoice.id,
        params: {
          printSettings: this.printSettings
        }
      })
        .then((response) => {
          if (response.success) {
            this.$h.toastSuccess(
              this.$t('toasts.peppol.sent_to_peppol_network')
            )
            this.$emit('refresh-invoice')
          } else {
            this.$h.toastWarning(response.message)
          }
        })
        .finally(() => {
          this.sending = false
        })
    }
  }
}
</script>
